import React, { useEffect, useState } from "react";
import { timeToSeconds2 } from "../../Utilitie";
import toast from "react-hot-toast";

const ADRMBlockPositionInsert = () => {
  const urlPrefixBlock = process.env.REACT_APP_URL_BLOCK_PREFIX;

  const keys = [
    "block_date",
    "dept",

    "total_corridor_blocks_agreed",
    "total_corridor_hours_agreed",

    "total_corridor_blocks_granted",
    "total_corridor_hours_granted",

    "created_by",
  ];

  const DepartmentDropdown = ["Engg", "TRD", "S&T"];
  const today = new Date().toISOString().slice(0, 10);

  const [entries, setEntries] = useState(() =>
    DepartmentDropdown.map((dept) => ({
      block_date: today,
      dept,

      total_corridor_blocks_agreed: "",
      total_corridor_hours_agreed: { hours: "", minutes: "" },

      total_corridor_blocks_granted: "",
      total_corridor_hours_granted: { hours: "", minutes: "" },

      created_by: "user",
    }))
  );

  const [allData, setAllData] = useState([]);

  useEffect(() => {
    const filedData = entries.map((entry) => {
      const obj = {};
      keys.forEach((key) => {
        if (key === "block_date") {
          obj[key] = entry[key] || today;
        } else if (
          key === "total_corridor_hours_agreed" ||
          key === "total_corridor_hours_granted"
        ) {
          const timeObj = entry[key] || { hours: "0", minutes: "0" };
          const timeStr = `${timeObj.hours || "0"}:${timeObj.minutes || "0"}`;
          obj[key] = timeToSeconds2(timeStr);
        } else if (key === "created_by") {
          obj[key] = entry[key] || "user";
        } else {
          obj[key] = entry[key] || "";
        }
      });
      return obj;
    });
    setAllData(filedData);
  }, [entries]);

  const handleChange = (rowIndex, key, value) => {
    setEntries((prev) => {
      const newEntries = [...prev];
      newEntries[rowIndex] = { ...newEntries[rowIndex], [key]: value };
      return newEntries;
    });
  };

  const handleHourMinuteChange = (rowIndex, key, field, value) => {
    if (field === "minutes" && value > 59) return;
    setEntries((prev) => {
      const newEntries = [...prev];
      newEntries[rowIndex] = {
        ...newEntries[rowIndex],
        [key]: {
          ...newEntries[rowIndex][key],
          [field]: value,
        },
      };
      return newEntries;
    });
  };

  const handleDateChange = (date) => {
    setEntries((prev) => prev.map((entry) => ({ ...entry, block_date: date })));
  };

  const handleClear = () => {
    setEntries(
      DepartmentDropdown.map((dept) => ({
        block_date: today,
        dept,

        total_corridor_blocks_agreed: "",
        total_corridor_hours_agreed: "00:00",
        total_corridor_hours_agreed: { hours: "", minutes: "" },

        total_corridor_blocks_granted: "",
        total_corridor_hours_granted: "00:00",
        total_corridor_hours_granted: { hours: "", minutes: "" },

        created_by: "user",
      }))
    );
  };

  const handleSubmit = async () => {
    try {
      const response = await fetch(
        `${urlPrefixBlock}insertBlockPositionAdrmDaily`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(allData),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      await response.json();
      toast.success("Upload successful");
    } catch (error) {
      toast.error("Error submitting data");
    }

    handleClear();
  };

  return (
    <div className="papaDiv">
      <h5 className="bg-dark text-white text-center p-2">
        Insert Data In ADRM Daily Block Position
      </h5>

      <div className="table-responsive">
        <table className="table table-bordered table-striped mb-4">
          <thead className="table-dark text-center align-middle">
            <tr>
              {keys.map(
                (key, i) =>
                  key !== "created_by" && (
                    <th key={i}>
                      {key
                        .replace("dept", "department")
                        .toUpperCase()
                        .replace(/_/g, " ")}
                    </th>
                  )
              )}
            </tr>
          </thead>
          <tbody>
            {entries.map((entry, rowIndex) => (
              <tr key={rowIndex}>
                {keys.map((key, colIndex) => {
                  if (key === "created_by") return null;

                  if (key === "block_date") {
                    return (
                      <td key={colIndex}>
                        {rowIndex === 0 ? (
                          <input
                            type="date"
                            className="form-control form-control-sm"
                            value={entry.block_date}
                            onChange={(e) => handleDateChange(e.target.value)}
                          />
                        ) : (
                          <input
                            type="date"
                            className="form-control form-control-sm"
                            value={entry.block_date}
                            disabled
                          />
                        )}
                      </td>
                    );
                  }

                  if (key === "dept") {
                    return <td key={colIndex}>{entry.dept}</td>;
                  }

                  if (
                    key === "total_corridor_hours_agreed" ||
                    key === "total_corridor_hours_granted"
                  ) {
                    return (
                      <td key={colIndex}>
                        <div className="d-flex justify-content-center">
                          <input
                            type="number"
                            placeholder="HH"
                            className="w-25 form-control form-control-sm "
                            min="0"
                            value={entry[key]?.hours || ""}
                            onChange={(e) =>
                              handleHourMinuteChange(
                                rowIndex,
                                key,
                                "hours",
                                e.target.value
                              )
                            }
                          />
                          <span className="fw-bolder m-2">:</span>

                          <input
                            type="number"
                            placeholder="MM"
                            className="w-25 form-control form-control-sm"
                            min="0"
                            max="59"
                            value={entry[key]?.minutes || ""}
                            onChange={(e) =>
                              handleHourMinuteChange(
                                rowIndex,
                                key,
                                "minutes",
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </td>
                    );
                  }

                  return (
                    <td key={colIndex}>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        value={entry[key]}
                        onChange={(e) =>
                          handleChange(rowIndex, key, e.target.value)
                        }
                      />
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="text-center mt-4">
        <button
          className="btn btn-outline-danger m-2 px-5"
          onClick={handleClear}
        >
          Clear
        </button>
        <button
          className="btn btn-outline-success m-2 px-5"
          onClick={handleSubmit}
        >
          Upload
        </button>
      </div>
    </div>
  );
};

export default ADRMBlockPositionInsert;
